import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './store';
import ErrorBoundary from './components/ErrorBoundary';
import { ToastProvider, TooltipProvider } from '@/design-system';
import { installBackForwardCacheGuard } from './utils/backForwardCache';
import './index.css';
import './billing-styles.css';
import './design-system/keyframes.css';

// B60 — Back after a sign-out must never put a signed-in page back on screen.
installBackForwardCacheGuard(() => {
  const { isAuthenticated, user, token } = store.getState().auth;
  return isAuthenticated || !!user || !!token;
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          {/* Wave 4.1.A — design-system providers. ToastProvider exposes
              useToast() to any descendant. TooltipProvider is required by
              @radix-ui/react-tooltip primitives. */}
          <TooltipProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </TooltipProvider>
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);
